import { twMerge } from "tailwind-merge";
import { Button, Card, H5, H6, Icon, IconType } from "@sellar-io/components";

export const StatePrompts = ({
  title,
  description,
  tertiaryCta,
  primaryCta,
  onClick,
  onClickTertiary,
  icon,
}: {
  title: string;
  description?: string;
  tertiaryCta?: string;
  primaryCta?: string;
  onClick?: () => void;
  onClickTertiary?: () => void;
  icon?: IconType;
}) => {
  return (
    <Card
      className={twMerge(
        "bg-white",
        "flex flex-col items-center gap-2 px-5 py-10 text-center",
      )}
    >
      <H5>{title}</H5>
      <H6>{description}</H6>
      {primaryCta && onClick && (
        <Button color={"primary"} onClick={onClick}>
          <>
            {icon && <Icon icon={icon} />}
            {primaryCta}
          </>
        </Button>
      )}
      {tertiaryCta && onClickTertiary && (
        <Button color={"tertiary"} onClick={onClickTertiary}>
          {tertiaryCta}
        </Button>
      )}
    </Card>
  );
};
